import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MENU_OPEN, MENU_CLOSE_ALL } from 'store/actions';
import { getRotas } from 'services/auth';
import menuItem from 'menu-items';

// ==============================|| MENU ACTIVE MANAGER ||============================== //

const MenuActiveManager = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const currentPath = location.pathname;
        
        // Pega todos os itens do menu (estáticos + dinâmicos)
        let allMenuItems = [];
        
        try {
            // Função recursiva para coletar todos os itens do menu
            const collectMenuItems = (items) => {
                items.forEach(item => {
                    if (item.type === 'item' && item.url) {
                        allMenuItems.push(item);
                    } else if (item.children) {
                        collectMenuItems(item.children);
                    }
                });
            };
            
            // Coleta itens do menu estático (dashboard, etc.)
            collectMenuItems(menuItem.items);
            
            // Coleta itens do menu dinâmico (rotas do sistema)
            const rotas = JSON.parse(getRotas() || '[]');
            collectMenuItems(rotas);
            
        } catch (error) {
            console.error('Erro ao processar rotas do menu:', error);
        }

        // Debug
        console.log('MenuActiveManager - currentPath:', currentPath);
        console.log('MenuActiveManager - allMenuItems:', allMenuItems);

        // Primeiro fecha todos os menus
        dispatch({ type: MENU_CLOSE_ALL });

        // Tratamento especial para /dashboard/default -> deve ativar "Home"
        let activeItem = null;
        
        if (currentPath === '/dashboard/default') {
            // Procura pelo item "Home" (default)
            console.log('MenuActiveManager - Looking for dashboard/default item...');
            
            activeItem = allMenuItems.find(item => item.id === 'default');
            if (!activeItem) {
                activeItem = allMenuItems.find(item => item.title === 'Home');
            }
            if (!activeItem) {
                activeItem = allMenuItems.find(item => item.url === '/dashboard/default');
            }
            
            console.log('MenuActiveManager - Dashboard item found:', activeItem);
        } else {
            // Para outras rotas, procura pela URL exata
            activeItem = allMenuItems.find(item => item.url === currentPath);
        }
        
        if (activeItem) {
            console.log('MenuActiveManager - Setting active:', activeItem.title, activeItem.id);
            // Define apenas este item como ativo
            dispatch({ type: MENU_OPEN, id: activeItem.id });
        } else {
            console.log('MenuActiveManager - No matching menu item found for:', currentPath);
            
            // Se for /dashboard/default e não encontrou nos menus dinâmicos,
            // força a ativação do item 'default' (Home)
            if (currentPath === '/dashboard/default') {
                console.log('MenuActiveManager - Forcing Home activation for /dashboard/default');
                dispatch({ type: MENU_OPEN, id: 'default' });
            }
        }

    }, [location.pathname, dispatch]);

    return null; // Este componente não renderiza nada
};

export default MenuActiveManager;
